import React from "react";

const PageHeader = ({ title, description, margin = true }) => {
  return (
    <div className={`${margin ? "mb-6 sm:mb-8" : ""}`}>
      <h1 className="text-primaryText text-xl sm:text-2xl lg:text-3xl font-bold leading-tight mb-2">
        {title}
      </h1>
      {description && (
        <p className="text-sm sm:text-base text-[#6B7280] leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
};

export default PageHeader;
